import { KeyValueDefault } from '@/main/models/common';
import {
  QuoteNoSupplierAssignedItemResponse,
  RequoteProcurementItemResponse,
  RequoteProcurementSupplierResponse
} from '@/main/models/response';

export const INITIAL_FORM_STATE_REQUOTE: IRequoteRequest = {
  parts: []
};
export const INITIAL_FORM_STATE_PROCUREMENT = {
  suppliers: [] as IItemFormRequoteSupplierOrdered[]
};
export type IRequoteOrderedForm = typeof INITIAL_FORM_STATE_PROCUREMENT;

export type TypeSectionPart = 'abovePrive' | 'unanswered';
export interface IQuoteNoSupplierAssignedItemResponse
  extends QuoteNoSupplierAssignedItemResponse {
  sectionPart: TypeSectionPart;
  partType: KeyValueDefault | null;
  isSelected: boolean;
}
export interface IRequoteRequest {
  parts: IQuoteNoSupplierAssignedItemResponse[];
}

export interface IItemFormRequoteOrdered
  extends RequoteProcurementItemResponse {
  partType: KeyValueDefault | null;
  isSelected: boolean;
}
export interface IItemFormRequoteSupplierOrdered
  extends RequoteProcurementSupplierResponse {
  items: IItemFormRequoteOrdered[];
}

